import moment from 'moment';
import store from '@/store';
import router from '@/router';
import konstanten from '@/js/konstanten';

export const DATE_FORMATS = {
  API_DATE_FORMAT: 'yyyy-MM-DD',
  API_DATE_TIME_FORMAT: 'yyyy-MM-DDTHH:mm:ss',
  UI_DATE_FORMAT: 'DD.MM.yyyy',
  UI_DATE_TIME_FORMAT: 'DD.MM.yyyy HH:mm:ss',
};

export function formatDate(value, sourceFormat, targetFormat) {
  return moment(value, sourceFormat).format(targetFormat);
}

export function formatCurrency(value) {
  let output = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
  output = output.slice(0, output.length - 2);
  if (output === 'NaN') {
    return undefined;
  }
  return output;
}

export function formatCurrencyToNumber(input, truncEuro) {
  if (input === undefined) {
    return undefined;
  }
  let output = input.replaceAll(/[a-z]/gi, '').replaceAll('\.', '').replace(',', '.');
  if (output.indexOf(',') > -1) {
    output = output.slice(0, output.indexOf(','));
  }
  if (output.indexOf('.') > -1) {
    if (truncEuro) {
      output = output.slice(0, output.indexOf('.'));
    } else if (output.indexOf('.') < output.length - 3) {
      output = output.slice(0, output.indexOf('.') + 3);
    }
  }
  return parseFloat(output);
}

export function formatFlaeche(input) {
  let output = new Intl.NumberFormat('de-DE').format(input);
  return (output && output !== 'NaN') ? output : undefined;
}

export function formatFlaecheToNumber(input) {
  if (input === undefined) {
    return undefined;
  }
  let output = input.replaceAll(/[a-z]/gi, '').replaceAll('\.', '').replace(',', '.');
  if (output.indexOf('.') > -1) {
    output = output.slice(0, output.indexOf('.'));
  }
  return parseInt(output);
}

export function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function showLoadingOverlay() {
  store.dispatch('setLoading', true, {root: true});
}

export function hideLoadingOverlay() {
  store.dispatch('setLoading', false, {root: true});
}

export function clearLastDisplayedMessage() {
  store.dispatch('clearAlert', undefined, {root: true});
}

export function displayErrorMessage(message) {
  store.dispatch('setAlert', {type: 'error', message: message}, {root: true});
}

export function displayInfoMessage(message) {
  store.dispatch('setAlert', {type: 'info', message: message}, {root: true});
}

export function displaySmallInfoMessage(message) {
  store.dispatch('setSnackbar', {message: message}, {root: true});
}

export function clearSmallInfoMessage() {
  store.dispatch('clearSnackbar', undefined, {root: true});
}


export function displayAxiosError(error) {
  const statusErrorMessages = {
    401: 'Zugriff verweigert',
    403: 'Zugriff verweigert',
    500: 'Es ist ein interner Fehler aufgetreten',
    502: 'Es ist ein interner Fehler aufgetreten',
    404: 'Nicht gefunden',
    400: 'Es ist ein Fehler bei der Anfrage aufgetreten',
  };

  let msg = error.message;
  let errorResp = error.response?.data.message;
  let status = error.response?.data.status;
  let statusMessage = '';
  if (status && statusErrorMessages[status]) {
    statusMessage = statusErrorMessages[status];
  }

  store
    .dispatch('setAlert', {type: 'error', message: errorResp ? errorResp : statusMessage ? statusMessage : msg}, {root: true})
    .then(() => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        store.dispatch('user/setUsername', undefined, {root: true});
        store.dispatch('user/setEmailVerified', false, {root: true});
        let ref = store.getters['registrierung/user'].userReferer;
        let q = ref ? {location: ref} : {};
        router.push({path: '/login', query: q});
      }
    });
}

export function extrahiereReferer(query) {
  const str = query.location;
  if (str) {
    return str.length > konstanten.SCOUT_LOCATION_LENGTH
      ? str.substring(0, konstanten.SCOUT_LOCATION_LENGTH)
      : str;
  } else {
    return 'Sprengnetter';
  }
}

export function locationQuery(query) {
  const str = extrahiereReferer(query);
  return str ? {location: str} : {};
}

export function hasFileType(fileName, type) {
  let fnEnd = fileName.substring(fileName.length - (type.length + 1));
  return fnEnd.startsWith('.') && fnEnd.substring(1).toLowerCase() === type.toLowerCase();
}

export function preventKeydownOnTextSize(e, field) {
  if (field?.length >= konstanten.MAX_TEXT_LENGTH
    && !konstanten.ALLOWED_KEYS.includes(e.key)
    && !(e.ctrlKey && (e.key === 'c' || e.key === 'x'))) {
    e.preventDefault();
  }
}

export function validateGridWidth(val) {
  let n = parseInt(val);
  // Number of columns in the vuetify grid are 12
  return !isNaN(n) && n >= 1 && n <= 12;
}
